import NotificationActions from 'client/js/main/actions/NotificationActions';
import dash_api from 'client/js/main/support/dash_api';
import type {
  GetIngestorsRequestActionPayload,
  GetIngestorsResponseActionPayload,
} from 'client/js/redux/domains/EmailIngestor/EmailIngestor.types';
import { ReduxAsyncAction } from 'client/js/redux/services/ReduxAsyncAction';
import type { Action } from 'redux';

const GetIngestors = new ReduxAsyncAction<
  'EMAIL_INGESTOR_GET_INGESTORS',
  GetIngestorsRequestActionPayload,
  GetIngestorsResponseActionPayload | undefined
>('EMAIL_INGESTOR_GET_INGESTORS');

GetIngestors.registerRequest(async (payload) => {
  try {
    const response = await dash_api.get<GetIngestorsResponseActionPayload>('/v1/roi/email-ingestors', {
      params: payload,
    });

    return {
      data: response.data.data,
      pagination: response.data.pagination,
    };
  } catch (error) {
    NotificationActions.showNotification('Error occurred while fetching email importers', 'error');
    throw error;
  }
});

export const GET_INGESTORS = GetIngestors.actionNamespaceConstants;

export const getIngestors = GetIngestors.request;

export type GetIngestorsResponseAction = Action<typeof GET_INGESTORS.response> & { data: GetIngestorsResponseActionPayload };
